import {
  PostVerificarDocumentoIntegrante,
  GetIdentificacionIntegranteExtranjero
} from "../../../reducers/personaReferencia";

export interface VerificarDocumentoIntegranteStore
  extends PostVerificarDocumentoIntegrante,
    GetIdentificacionIntegranteExtranjero {}

export const verificarDocumentoIntegranteStore: (
  state
) => VerificarDocumentoIntegranteStore = state => {
  const { personaReferencia } = state;
  return {
    verificacionDocumentoIntegrante:
      personaReferencia.verificacionDocumentoIntegrante,
    postingVerificarDocumentoIntegrante:
      personaReferencia.postingVerificarDocumentoIntegrante,
    postingVerificarDocumentoIntegranteError:
      personaReferencia.postingVerificarDocumentoIntegranteError,
    identificacionIntegranteExtranjero:
      personaReferencia.identificacionIntegranteExtranjero,
    gettingIdentificacionIntegranteExtranjero:
      personaReferencia.gettingIdentificacionIntegranteExtranjero,
    gettingIdentificacionIntegranteExtranjeroError:
      personaReferencia.gettingIdentificacionIntegranteExtranjeroError
  };
};
